import { SEV_STYLES } from "@/lib/severity";

export function SeverityBadge({ severity, className = "" }) {
  const s = SEV_STYLES[severity] || SEV_STYLES.Low;
  return (
    <span
      className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-md text-[11px] font-semibold font-mono uppercase tracking-wide border ${s.badge} ${className}`}
      data-testid={`sev-${severity?.toLowerCase()}`}
    >
      <span className="h-1.5 w-1.5 rounded-full" style={{ background: s.hex }} />
      {severity}
    </span>
  );
}

export function StatusPill({ status }) {
  const M = {
    Active: "bg-slate-100 text-slate-700 border-slate-300",
    Accepted: "bg-cyan-50 text-cyan-800 border-cyan-300",
    Mitigated: "bg-emerald-50 text-emerald-800 border-emerald-300",
    Closed: "bg-slate-100 text-slate-500 border-slate-300",
    PendingAcceptance: "bg-amber-50 text-amber-800 border-amber-300",
    Pending: "bg-amber-50 text-amber-800 border-amber-300",
    Approved: "bg-emerald-50 text-emerald-800 border-emerald-300",
    Rejected: "bg-rose-50 text-rose-800 border-rose-300",
    ChangesRequested: "bg-orange-50 text-orange-800 border-orange-300",
    Expired: "bg-slate-100 text-slate-500 border-slate-300",
    Open: "bg-rose-50 text-rose-800 border-rose-300",
    InProgress: "bg-amber-50 text-amber-800 border-amber-300",
  };
  return (
    <span className={`inline-flex items-center px-2 py-0.5 rounded-md text-[11px] font-medium border ${M[status] || "bg-slate-100 text-slate-700 border-slate-300"}`}>
      {status}
    </span>
  );
}
